var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "video__player",
      class: [
        _vm.videoPlayerStoreState.fullscreen ? "video__player--fullscreen" : "",
        _vm.hasPlayed ? "video__player--has-been-played" : ""
      ]
    },
    [
      _c("div", { ref: "playerContainer" }),
      _vm._v(" "),
      _vm._t("controls", [
        _vm.player
          ? _c("player-controls", {
              ref: "playerControls",
              attrs: { "data-ui-section": "controls", player: _vm.player }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm._t("default", null, { player: _vm.player })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }